import * as dateFnsCompat from 'utils/date-fns-compat';

import fp from 'lodash/fp';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { compose, defaultProps, mapProps, withProps, withStateHandlers } from 'recompose';
import { SelectFormField } from '.';
import { defaultMinYear, months } from '../../constants';
import { currentYear, noCapMap, startOfYear } from '../../utils';

export const onDateFieldChange = (date, onChange, setDate, setTouched, touched) =>
  (transform, fieldName) => (e) => {
    const nextDate = ((parsedValue) => !isNaN(parsedValue) ?
      transform(date || startOfYear(), parsedValue) :
      null
    )(parseInt(e.target.value, 10))

    setTouched(fieldName)

    setDate(nextDate)

    const updatedTouched = {
      ...touched,
      [fieldName]: true
    }

    if (updatedTouched.day && updatedTouched.month && updatedTouched.year) {
      onChange(nextDate, fieldName)
    } else {
      onChange(undefined, fieldName)
    }

  }

export const DateSelectField = ({ date, onChange, disabled, emptyOption, untouched, label }) => (
  <SelectFormField
    id='date'
    label={label}
    disabled={disabled}
    value={untouched ? '' : dateFnsCompat.getDay(date)}
    emptyOption={emptyOption}
    onChange={onChange}>
    {
      fp.map((day) =>
        <option key={day} value={day}>{day}</option>
      )(fp.range(1, (date ? dateFnsCompat.getDaysInMonth(date) : 31) + 1))
    }
  </SelectFormField>
);

export const MonthSelectField = ({ date, onChange, disabled, emptyOption, untouched, label }) => (
  <SelectFormField
    id='month'
    label={label}
    disabled={disabled}
    value={untouched ? '' : dateFnsCompat.getMonth(date)}
    emptyOption={emptyOption}
    onChange={onChange}>
    {
      noCapMap((month, index) =>
        <option key={month} value={index}>{month}</option>
      )(fp.values(months))
    }
  </SelectFormField>
);

export const YearSelectField = compose(
  defaultProps({
    futureYears: 0
  }),
  withProps(({ futureYears, minYear }) => ({
    maxYear: currentYear() + 1 + futureYears,
    minYear: minYear ? minYear : defaultMinYear
  }))
)(({ date, maxYear, minYear, onChange, disabled, emptyOption, untouched, label }) => (
  <SelectFormField
    id='year'
    label={label}
    disabled={disabled}
    value={untouched ? '' : dateFnsCompat.getYear(date)}
    emptyOption={emptyOption}
    onChange={onChange}>
    {
      fp.map((year) =>
        <option key={year} value={year}>{year}</option>
      )(fp.range(minYear, maxYear))
    }
  </SelectFormField>
))

const DateSelect = ({ date, onChange, disabled, futureYears, minYear, emptyOption, labels = {}, touched = { day: false, month: false, year: false } }) => (
  <Row className='xs-gutter'>
    <Col xs={12} sm={4}>
      <DateSelectField
        label={labels.day ? labels.day : 'Day'}
        date={date}
        disabled={disabled}
        emptyOption={emptyOption}
        untouched={!touched.day}
        onChange={onChange(dateFnsCompat.setDate, 'day')} />
    </Col>
    <Col xs={12} sm={4}>
      <MonthSelectField
        label={labels.month ? labels.month : 'Month'}
        date={date}
        disabled={disabled}
        emptyOption={emptyOption}
        untouched={!touched.month}
        onChange={onChange(dateFnsCompat.setMonth, 'month')} />
    </Col>
    <Col xs={12} sm={4}>
      <YearSelectField
        label={labels.year ? labels.year : 'Year'}
        date={date}
        disabled={disabled}
        futureYears={futureYears}
        minYear={minYear}
        emptyOption={emptyOption}
        untouched={!touched.year}
        onChange={onChange(dateFnsCompat.setYear, 'year')} />
    </Col>
  </Row>
);

export default compose(
  withStateHandlers(
    ({ date }) => ({
      date,
      touched: date ?
        {
          day: true,
          month: true,
          year: true
        } : {
          day: false,
          month: false,
          year: false
        }
    }),
    {
      setTouched: ({ touched }) => (field) => ({
        touched: {
          ...touched,
          [field]: true
        }
      }),
      setDate: () => (date) => ({
        date
      })
    }
  ),
  mapProps(({ date, onChange, disabled, futureYears, minYear, emptyOption, touched, setDate, setTouched, labels }) => ({
    date,
    disabled,
    onChange: onDateFieldChange(date, onChange, setDate, setTouched, touched),
    futureYears,
    minYear,
    emptyOption,
    touched,
    labels
  }))
)(DateSelect);



// WEBPACK FOOTER //
// ./src/containers/components/date-select.js